export const ORDER_STATUSES = [
  "Pending",
  "Approved",
  "Packed",
  "Shipped",
  "Fulfilled",
  "Rejected",
  "Delayed",
];

export const STATUS_CONFIG = {
  Pending: {
    label: "Pending",
    icon: "⏳",
    colorClass: "bg-gray-600",
    next: ["Approved", "Rejected"],
  },
  Approved: {
    label: "Approved",
    icon: "✅",
    colorClass: "bg-blue-600",
    next: ["Packed"],
  },
  Packed: {
    label: "Packed",
    icon: "📦",
    colorClass: "bg-indigo-600",
    next: ["Shipped"],
  },
  Shipped: {
    label: "Shipped",
    icon: "🚚",
    colorClass: "bg-purple-600",
    next: ["Fulfilled"],
  },
  Fulfilled: {
    label: "Fulfilled",
    icon: "✔️",
    colorClass: "bg-green-600",
    next: [],
  },
  Rejected: {
    label: "Rejected",
    icon: "❌",
    colorClass: "bg-red-700",
    next: [],
  },
  Delayed: {
    label: "Delayed",
    icon: "⚠️",
    colorClass: "bg-yellow-600",
    next: [],
  },
};
